<app-loading-wrapper [loading]="loading">
    <app-text [alias]="'reg_staff_ip_grading'"></app-text>


    <div *ngIf="questions && formGroup">
        <form *ngIf="questions" [formGroup]="formGroup">
            <div class="row ">
                <div class="small-12 medium-12 large-6 columns">
                    <mat-card>
                        <mat-card-title>Terminal Course with Final Grades</mat-card-title>
                        <app-text [alias]="'reg_staff_ip_grading_search_main_course'"></app-text>
                        <div class="row ">

                            <div class="small-12 medium-12 large-6 columns">
                                <app-question [question]="questions.termCode"
                                              (controlValueChange)="onSearchMainCourseByCRN()"></app-question>
                            </div>
                            <div class="small-12 medium-12 large-6 columns">
                                <app-question [question]="questions.crn"
                                              (controlValueChange)="onSearchMainCourseByCRN()"></app-question>
                            </div>
                        </div>
                        <div class="row">
                            <div class="small-12 medium-12 large-12 columns">

                                <app-button-list>
                                    <app-button [icon]="'cancel'" (clickedEvent)="reset()">Reset</app-button>
                                    <app-button [icon]="'search'" (clickedEvent)="onSearchMainCourseByCRN()">Search
                                    </app-button>
                                </app-button-list>

                            </div>
                        </div>

                    </mat-card>
                </div>
                <div class="small-12 medium-12 large-6 columns">
                    <mat-card *ngIf="isCourseLoaded">
                        <mat-card-title>Series Course to be Updated</mat-card-title>
                        <app-text [alias]="'reg_staff_ip_grading_search_course_to_update'"></app-text>
                        <div class="row">

                            <div class="small-12 medium-12 large-6 columns">
                                <app-question [question]="questions.searchTermCode"
                                              (controlValueChange)="onSearchCourseByCRN()"></app-question>
                            </div>
                            <div class="small-12 medium-12 large-6 columns">
                                <app-question [question]="questions.searchCourseCrn"
                                              (controlValueChange)="onSearchCourseByCRN()"></app-question>
                            </div>
                        </div>
                        <div class="row">
                            <div class="small-12 medium-12 large-12 columns">
                                <app-button-list>
                                    <app-button [loading]="saving" (clickedEvent)="search()" [icon]="'search'">
                                        Search
                                    </app-button>
                                    <app-button [loading]="saving" (clickedEvent)="cancelAdd()" icon="'cancel'">
                                        Clear
                                    </app-button>
                                </app-button-list>
                            </div>
                        </div>
                        <div class="row">
                            <div class="small-12 medium-12 large-12 columns">
                                <app-loading-wrapper [loading]="searchCourseLoading"
                                                     *ngIf="this.getFormValue()?.searchTermCode&& this.getFormValue()?.searchCourseCrn">
                                    <br>
                                    <div *ngIf="!searchCourseLoading && !foundCourse">
                                        Course not found for Term:  {{this.getFormValue()?.searchTermCode}} and
                                        CRN: {{this.getFormValue()?.searchCourseCrn}}.
                                    </div>
                                    <div *ngIf="!searchCourseLoading&&foundCourse">
                                        <mat-card>
                                            <mat-card-title>
                                                {{resultCourse.courseRoster.course.termCodeDescription}}
                                                (CRN: {{resultCourse.courseRoster.course.crn}})
                                            </mat-card-title>
                                            <mat-card-subtitle>
                                                {{resultCourse.courseRoster.course.subjectCode}} {{resultCourse.courseRoster.course.courseNumber}} {{resultCourse.courseRoster.course.sectionNumber}}
                                            </mat-card-subtitle>
                                            <mat-card-content>
                                                <div class="row collapse">
                                                    <div class="large-12 column">
                                                        {{resultCourse.courseRoster.course.courseTitle}}
                                                    </div>
                                                </div>
                                                <div class="row collapse">
                                                    <div class="large-6 column">
                                                        Matched Students: <a
                                                            (click)="viewStudent(resultCourse.studentMatchList)">{{resultCourse.studentMatchList?.length}}</a>
                                                    </div>
                                                    <div class="large-6 column">
                                                        Unmatched Students: <a
                                                            (click)="viewStudent(resultCourse.studentNotMatchList)">{{resultCourse.studentNotMatchList?.length}}</a>
                                                    </div>
                                                </div>

                                            </mat-card-content>

                                        </mat-card>

                                    </div>
                                    <app-button-list *ngIf="!searchCourseLoading&&foundCourse">
                                        <app-button [loading]="saving" (clickedEvent)="addCourse()" [icon]="'save'">
                                            Add
                                        </app-button>
                                        <app-button [loading]="saving" (clickedEvent)="cancelAdd()" [icon]="'cancel'">
                                            Cancel
                                        </app-button>
                                    </app-button-list>
                                </app-loading-wrapper>
                            </div>
                        </div>

                    </mat-card>
                </div>
            </div>
            <div class="row" *ngFor="let message of postGradeResultMessage">
                <div class="small-12 medium-12 large-12 columns">
                    {{message}}
                </div>
            </div>
            <div class="row">
                <div class="small-12 medium-12 large-12 columns">
                    <mat-accordion *ngIf="courseListToProcess?.length>0">
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    IP Course To Update ({{courseListToProcess?.length}})
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-text [alias]="'reg_staff_ip_grading_list_course_added'"></app-text>

                            <mat-card *ngFor="let cr of courseListToProcess">
                                <mat-card-content>
                                    <div class="row collapse">
                                        <div class="large-9 column">
                                            <div>{{cr.courseRoster.course.termCodeDescription}}
                                                (CRN: {{cr.courseRoster.course.crn}})
                                            </div>

                                            <div>{{cr.courseRoster.course.subjectCode}} {{cr.courseRoster.course.courseNumber}} {{cr.courseRoster.course.sectionNumber}}</div>

                                            <div>{{cr.courseRoster.course.courseTitle}}</div>

                                            <div class="row collapse">
                                                <div class="large-6 column">
                                                    Matched Students: <a
                                                        (click)="viewStudent(cr.studentMatchList)">{{cr.studentMatchList?.length}}</a>
                                                </div>
                                                <div class="large-6 column">
                                                    Unmatched Students: <a
                                                        (click)="viewStudent(cr.studentNotMatchList)">{{cr.studentNotMatchList?.length}}</a>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="large-3 column">
                                            <app-button-list>
                                                <app-button [icon]="'delete'"
                                                            (clickedEvent)="removeCourse(cr)"></app-button>
                                            </app-button-list>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
            <div class="row" *ngIf="showRoster">
                <div class="large-12 medium-12 small-12 column alight-right">
                    <br>
                    <mat-accordion>
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Course Roster
                                    for  {{selectedCourse.termCode}}  {{selectedCourse.subjectCode}}  {{selectedCourse.courseNumber}}   {{selectedCourse.sectionNumber}}
                                    ({{selectedCourse.crn}})
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-text [alias]="'reg_staff_ip_grading_main_course_roster'"></app-text>
                            <mat-card>
                                <mat-card-content>
                                    <app-object-list-roster [inTermCode]="selectedCourse?.termCode"
                                                            [inCrn]="selectedCourse?.crn" [inIPGrading]="true"
                                                            (dataSourceStudentList)="updateMainRosterList($event)"></app-object-list-roster>

                                </mat-card-content>
                            </mat-card>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
            <div class="row" *ngIf="mainCourseSearchDone && !mainCourseFound">
                <div class="large-12 medium-12 small-12 column alight-right">
                    <br>
                    <mat-card>
                        <mat-card-content>
                            Course Term: {{this.questions.termCode.input.control.value}}
                            CRN: {{this.questions.crn.input.control.value}} has not been graded.
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <div class="row" *ngIf="this.ipStudentForUpdate?.length> 0">
                <div class="small-12 medium-12 large-12 columns">
                    <br>
                    <mat-accordion>
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Preview Grades To Be Updated
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-text [alias]="'reg_staff_ip_grading_preview'"></app-text>
                            <mat-card>
                                <mat-card-content>
                                    <table mat-table matSort [dataSource]="postGradeDataSource"
                                           [hidden]="!ipStudentForUpdate">
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                sortActionDescription="Sort by name"
                                                class="header-row">
                                                Name (Last, First)
                                            </th>
                                            <td mat-cell *matCellDef="let student"><a
                                                    href="mailto:{{student.emailAddress}}"> {{student.bannerLastName}}
                                                , {{student.bannerFirstName}}</a></td>
                                        </ng-container>
                                        <ng-container matColumnDef="studentId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                sortActionDescription="Sort by Student ID"
                                                class="header-row">Student ID
                                            </th>
                                            <td mat-cell *matCellDef="let student">{{student.studentId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="gradeBanner">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                sortActionDescription="Sort by Banner Grade"
                                                class="header-row">Banner<br>Grade
                                            </th>
                                            <td mat-cell *matCellDef="let student">{{student.gradeBanner}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="gradeIGrade">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                sortActionDescription="Sort by IGrade"
                                                class="header-row">IGrade
                                            </th>
                                            <td mat-cell *matCellDef="let student">{{student.gradeIGrade}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="gradeRule">
                                            <th mat-header-cell *matHeaderCellDef class="header-row">Grade<br>Rule</th>
                                            <td mat-cell *matCellDef="let student">{{student.gradeRule}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="gradeType">
                                            <th mat-header-cell *matHeaderCellDef class="header-row">Grade<br>Type</th>
                                            <td mat-cell *matCellDef="let student">{{student.gradeType}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="courseList">
                                            <th mat-header-cell *matHeaderCellDef class="header-row">Courses to be Updated
                                            </th>
                                            <td mat-cell *matCellDef="let student">{{student.courseList}}</td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="postGradeDisplayColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: postGradeDisplayColumns;"></tr>
                                    </table>

                                    <div class="rows">
                                        <div class="small-12 medium-12 large-12 columns">
                                            <app-button-list>
                                                <app-button [icon]="'arrow_upward'"
                                                            (clickedEvent)="submitIPGrade()">Submit
                                                </app-button>
                                                <app-button [loading]="saving" (clickedEvent)="reset()"
                                                            [icon]="'cancel'">
                                                    Cancel
                                                </app-button>
                                            </app-button-list>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </form>

    </div>
</app-loading-wrapper>
